import { h } from 'preact'; /** @jsx h */
import ProductItem from '../ProductItem/ProductItem';
import './productList.scss';

const ProductList = ({ title, emptyMessage, products, shownProductsCount }) => {
    return (
        <div className="ws-products-list">
            {/* <h2 className="ws-list-title">{title}</h2> */}
            <div className="ws-list-items">
                {/* slice products to max shownProducts */}
                {products.length > 0 ? (
                    products?.slice(0, shownProductsCount)?.map(product => {
                        return <ProductItem key={product.id} product={product} />;
                    })
                ) : (
                    <div className="ws-no-products">
                        <p>{emptyMessage}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductList;
